import React from "react";

const EmptyBoxSvg = () => {
  return (
    <>
      <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5"
          y="31"
          width="31.75"
          height="21.8966"
          rx="4"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <path
          d="M10 43H27M10 48H19.0152"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <rect
          x="9.37891"
          y="34.2852"
          width="6.02155"
          height="6.02155"
          rx="2"
          fill="#88A8D3"
        />
        <rect
          x="13"
          y="86"
          width="31.75"
          height="21.8966"
          rx="4"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <path
          d="M18 98H35M18 103H27.0152"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <rect
          x="17.3789"
          y="89.2852"
          width="6.02155"
          height="6.02155"
          rx="2"
          fill="#88A8D3"
        />
        <rect
          x="90"
          y="42"
          width="31.75"
          height="21.8966"
          rx="4"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <path
          d="M95 54H112M95 59H104.015"
          stroke="#88A8D3"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <rect
          x="94.3789"
          y="45.2852"
          width="6.02155"
          height="6.02155"
          rx="2"
          fill="#88A8D3"
        />
        <rect
          x="47"
          y="54"
          width="31.75"
          height="21.8966"
          rx="4"
          stroke="#D0D4E6"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <path
          d="M51.9258 66.043H68.8956M51.9258 69.8749H60.9249"
          stroke="#D0D4E6"
          strokeWidth="3.00068"
          strokeLinecap="round"
        />
        <rect
          x="51.3789"
          y="57.2852"
          width="6.02155"
          height="6.02155"
          rx="2"
          fill="#D0D4E6"
        />
        <path
          d="M90.7415 36.7415C85.6423 31.6423 79.4984 28.2246 72.9988 26.4883C62.4545 23.6715 50.9739 25.2799 41.4988 31.3137M23.5597 58.9988C22.6082 65.5263 23.2883 72.2458 25.6 78.4988M54.4988 103.477C64.4806 105.591 75.121 103.819 83.9988 98.1601M96.4735 85.4988C99.5221 80.5541 101.382 75.0843 102.054 69.4988"
          stroke="#D9E5FF"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.3352 43.4083C72.546 31.6191 53.4319 31.6191 41.6427 43.4083C29.8535 55.1975 29.8535 74.3116 41.6427 86.1008C52.5689 97.027 69.7869 97.8268 81.6342 88.5002L98.2617 105.128C99.6931 106.559 102.014 106.559 103.445 105.128C104.876 103.696 104.876 101.376 103.445 99.9443L86.8076 83.3067C96.0569 71.4624 95.2328 54.3059 84.3352 43.4083ZM46.5924 48.3581C55.648 39.3025 70.3299 39.3025 79.3854 48.3581C88.4409 57.4136 88.4409 72.0955 79.3854 81.151C70.3299 90.2066 55.648 90.2066 46.5924 81.151C37.5369 72.0955 37.5369 57.4136 46.5924 48.3581Z"
          fill="#184680"
        />
      </svg>
    </>
  );
};

export default EmptyBoxSvg;
